import { authenticatedHttpClient } from './httpClient';
import type { GlobalLegalDocument } from '../models/legal';

export const getGlobalLegal = async (): Promise<GlobalLegalDocument | null> => {
  try {
    const data = await authenticatedHttpClient.get<GlobalLegalDocument>('/legal');
    const hasTermsVersion = Boolean(data?.terms?.version);
    const hasPrivacyVersion = Boolean(data?.privacyPolicy?.version);
    if (!hasTermsVersion && !hasPrivacyVersion) {
      return null;
    }
    return {
      terms: {
        es: data.terms?.es ?? '',
        en: data.terms?.en ?? '',
        version: data.terms?.version ?? '',
      },
      privacyPolicy: {
        es: data.privacyPolicy?.es ?? '',
        en: data.privacyPolicy?.en ?? '',
        version: data.privacyPolicy?.version ?? '',
      },
    };
  } catch (error) {
    console.error('Error loading global legal document:', error);
    return null;
  }
};
